//Actions
import { SET_API_KEYS_DATA, SET_API_KEYS_LOADER, LOGOUT } from '~/redux/actions/action-types';

const initialState = {
  apiKeys: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 10,
  totalApiKeysInDB: null,
  loading: false,
};

const apiKeysReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_API_KEYS_DATA:
      return {
        ...state,
        apiKeys: payload.rows,
        rowsCount: payload.count,
        totalApiKeysInDB: payload.totalRecordsInDB,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
      };
    case SET_API_KEYS_LOADER:
      return { ...state, loading: payload };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { apiKeysReducers };
